import type { OfferQuery, OfferQueryVariables } from '#shared/types/goliath/goliath.types';

export default async (
  params: OfferQueryVariables,
  progress = true,
  skipCache = false,
  signal: AbortSignal | undefined = undefined
): Promise<OfferWithProduct> => {
  const { $goliathApi } = useNuxtApp();
  const data = await $goliathApi<OfferQueryVariables, OfferQuery, 'offerBySlugs'>(
    'offer-by-slugs',
    params,
    'offerBySlugs',
    progress,
    skipCache,
    signal
  );
  if (data?.product) {
    return {
      ...data,
      product: data.product,
    };
  }

  throw createError({
    statusCode: 404,
    statusMessage: 'No suitable response received from goliath. Missing "product" payload.',
  });
};
